export const CONTRACT_ROUTES = {
  CONTRACT_PAGE: '/my-home/contracts',
  CONTRACT_FTN_AUTHENTICATION: '/authentication/contracts',
  CONTRACT_DOCUMENT: '/my-home/contracts/my-contract',
} as const;
